import React, { useCallback, useEffect, useState } from 'react';
import { Tappable } from '@vectord/components';
import cogoToast from 'cogo-toast';

import { DEFAULT_ERROR_MESSAGE } from 'data/defaultErrorMessage';
import { useBulkUpdateSbatGroupSuperBatchProjectsMutation } from 'features/classCreation';
import FieldErrors from 'components/FieldErrors';
import GlobalLoader from 'components/GlobalLoader';

export default function BulkUpdateSuperBatchProjectButton({
  sbatGroup,
  handleModalClose,
  superBatchProject,
  superBatchProjectEndTime,
  superBatchProjectStartTime,
}) {
  const { academy_project_id: academyProjectId, id: superBatchProjectId } =
    superBatchProject || {};
  const [error, setError] = useState(null);

  const [
    bulkUpdateSuperBatchProjects,
    { isSuccess, error: superBatchProjectError, isLoading: isUpdating },
  ] = useBulkUpdateSbatGroupSuperBatchProjectsMutation();

  const handleUpdate = useCallback(
    (event) => {
      event.preventDefault();
      if (superBatchProjectEndTime <= superBatchProjectStartTime) {
        cogoToast.error('End date must be greater than start date');
        return;
      }

      const startTime = new Date(superBatchProjectStartTime).toISOString();
      const endTime = new Date(superBatchProjectEndTime).toISOString();

      bulkUpdateSuperBatchProjects({
        sbatGroup,
        superBatchProject: {
          id: superBatchProjectId,
          startTime,
          endTime,
          academyProjectId,
        },
      });
    },
    [
      superBatchProjectId,
      superBatchProjectStartTime,
      academyProjectId,
      superBatchProjectEndTime,
      sbatGroup,
      bulkUpdateSuperBatchProjects,
    ]
  );

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Case Study is successfully updated!');
      handleModalClose();
    }
  }, [isSuccess, handleModalClose]);

  useEffect(() => {
    if (superBatchProjectError) {
      setError(superBatchProjectError?.data?.message || DEFAULT_ERROR_MESSAGE);
    }
  }, [superBatchProjectError]);

  return (
    <>
      <GlobalLoader isVisible={isUpdating} />
      <FieldErrors
        name="super_batch_project_date"
        errors={error}
      />
      <div className="m-t-xs">
        <Tappable
          className="btn btn-primary btn-long"
          component="button"
          onClick={handleUpdate}
          disabled={isUpdating}
        >
          Save Changes
        </Tappable>
      </div>
    </>
  );
}
